module.exports = {
    "ApiUrl": "https://resman-integration-api-test.icarehealth.com.au/api/",
    "IdentityServerAuthority": "https://resman-integration-identity-test.icarehealth.com.au",
    "SignalRUrl": "https://resman-integration-api-test.icarehealth.com.au/signalr",
    "AutomationEnabled": true,
    "MedicareTimeZone": "Australia/Melbourne"
};
